module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Title","author":"Author","edition":"Edition","year":"Year","read":"Read","lend":"Lent","lendName":"Name","grade":"Grade"},"fr":{"title":"Titre","author":"Auteur/trice","edition":"Edition","year":"Année","read":"Lu","lend":"Prêté","lendName":"Nom","grade":"Note"}}')
  delete Component.options._Ctor
}
